import { render, staticRenderFns } from "./CdkNewsItemDetailProvider.vue?vue&type=template&id=7660b42a&"
import script from "./CdkNewsItemDetailProvider.vue?vue&type=script&lang=ts&"
export * from "./CdkNewsItemDetailProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports